/* 
Currently this hook is only being used for wishlist items. If its ever to be used in a link transaction please update!
*/
import { AuthContext } from '../../context/AuthContext';
import { useContext, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import config from '../../config';
import NotificationSender from '../notifications/NotificationSender';

export const useItemPurchase = (item, itemTotalPrice, popupStatus, setShowPopup, setShowModal, triggerPurchase, onPurchaseSuccess, setConversationId) => {
    const {user: currentUser, balance, dispatch, socket_context} = useContext(AuthContext);
    const wishlistUsername = useParams().username;
    const itemId = item.itemId;
    
    useEffect(() => {
        if (!triggerPurchase) return;
        
        const giveHandler = async (item) => {
            if (balance < itemTotalPrice) {
                await popupStatus("Add money to your account balance.", "Close", () => {setShowPopup(false)});
                return;
            }

            const wishlistUserId = await fetchUserId(wishlistUsername);
            
            // popup to ask user if they want to give item
            const userConfirmed = await confirmGive(itemTotalPrice);
            
            // if user confirms transaction 
            if (userConfirmed) {
                // token from local storage
                const token = localStorage.getItem('token');
                const withdrawalResult = await performWithdrawal(itemTotalPrice, currentUser, token);
    
                // if withdrawal is sucessful
                if (withdrawalResult.success) {
                const updateResult = await updatePostAndBalance(wishlistUsername, itemId, itemTotalPrice);
                    // if withdrawal not successful
                    if (!updateResult.success) {
                        await popupStatus(updateResult.error, "Close");
                    } else {
                        // send notification if result is sucessful
                        handleNotification(item, socket_context, wishlistUserId, wishlistUsername);
                        // used for setting the wishlistItem to "purchased"
                        onPurchaseSuccess();
                    }
                } else {
                    // withdrawal error popup
                    await popupStatus(withdrawalResult.error, "Close");
                }
            }
        }
        giveHandler(item);
    }, [itemId, triggerPurchase])

    const fetchUserId = async (wishlistUsername) => {
        // token from local storage
        const token = localStorage.getItem('token');
        const response = await axios.get(`${config.apiUrl}/api/users/getId/${wishlistUsername}`, {
            headers: {
            'x-auth-token': token
            }
        });
        return response.data;
    };

    // confim the user wants to give this item
    const confirmGive = async (itemTotalPrice) => {
        setShowPopup(true);
        return new Promise((resolve) => {
        popupStatus(
            `Are you sure you want to give this item for $${itemTotalPrice}?`,
            "Yes",
            () => {
            resolve(true);
            setShowPopup(false); // Close the popup for confirming purchase
            },
            "No",
            () => {
            resolve(false);
            setShowPopup(false); // Close the popup for confirming purchase
            }
        );
        });
    };

    // Function to perform the withdrawal
    const performWithdrawal = async (itemTotalPrice, currentUser, token) => {
        try {
        // withdrawal from user's account
        const response = await axios.post(`${config.apiUrl}/api/billing-settings-withdrawal`, {
            balance: itemTotalPrice,
            userId: currentUser._id
        }, {
            headers: {
            'x-auth-token': token
            }
        });
        return { success: true, data: response.data };
        } catch (error) {
        return { success: false, error: error.response ? error.response.data : 'Network error' };
        }
    };

    // Function to update the post and balance
    const updatePostAndBalance = async (wishlistUsername, itemId, itemTotalPrice) => {
        try {
            // token from local storage
            const token = localStorage.getItem('token');
            // update wishlist item and create transaction document in db
            const res = await axios.post(`${config.apiUrl}/wishlists/purchase`, {
                wishlistUsername: wishlistUsername,
                purchaserUserId: currentUser._id,
                itemId: itemId,
                lastMessage: item.name,
            },{
                headers: {
                    'x-auth-token': token
                }
            });

            if(res.status === 200){
                dispatch({ type: "UPDATE_BALANCE", payload: balance - itemTotalPrice });
            }
 
            setShowModal(false); 
            setConversationId(res.data.conversationId);

            return { success: true };
        } catch (error) {
            return {sucess: false};
    }};

    const handleNotification = async (item, socket_context, wishlistUserId, wishlistUsername) => {
        // Emit the sendMessage event if the user is online
        const createdAt = new Date().toISOString();
        let socket = socket_context;
        let senderUserId = currentUser._id;
        let receiverUserId = wishlistUserId;
        let relatedPostId = wishlistUsername;
        let ebItemId = item.itemId;
        let ebItemTitle = item.title;
        let ebItemPhoto = item.image && item.image.imageUrl ? item.image.imageUrl : item.imageUrl;
        let amount = itemTotalPrice;
        let type = "item";
        let linkOrWishlist = "wishlist";
        let message = "gave you an item on your wishlist :)"
  
        await NotificationSender({
            socket,
            receiverUserId,
            senderUserId,
            relatedPostId,
            ebItemId,
            ebItemTitle,
            ebItemPhoto,
            amount,
            type,
            linkOrWishlist, 
            message,
            createdAt
        });
    }

};